<template>
  <main class="content">
    <!-- content -->
    <section class="intro">
      <div class='container'>
        <div class="intro-services">
          <div class="intro__text text-intro intro-services__text">
            <h1 class="text-intro__title">{{service.name}}</h1>
            <p class="text-intro__subtitle intro-service-text" v-if="service.cf[496]">{{service.cf[496]}}</p>
            <a  @click="$root.requestModal = 1, $root.modalText = '<iframe src=\''+service.cf[493]+'\'></iframe>'" class="intro__link" v-if="service.cf[493]">
              <picture><source srcset="/static/img/intro/play.svg" type="image/webp"><img src="/static/img/intro/play.svg" alt="" /></picture>
              <span>Как это происходит?</span>
            </a>
          </div>
          <div class="intro-services__info info-services" v-if="service.cf[497] || service.cf[498]">
            <h2 class="info-services__title">Как это работает</h2>
            <div class="info-services__subtitle" v-if="service.cf[497]">{{service.cf[497]}}></div>
            <ul class="info-services__list" v-if="service.cf[498]">
              <li class="info-services__link" v-if="cf" v-for="(cf, i) in service.cf[498].replace(/-/g, '<span>-</span>').split('\n')" :key="i" v-html="cf"></li>
            </ul>
          </div>
        </div>
      </div>
    </section>

    <section class="court" v-if="service.cf[499] || service.cf[500] || service.cf[501] || service.cf[502] || service.cf[503] || service.cf[504] || service.cf[505] || service.cf[506]">
      <div class='container'>
        <div class="court__wrapper">
          <div class="court__inner inner-court">
            <div class="inner-court__text">
              <span class="inner-court__info" v-if="service.cf[499]">{{service.cf[499]}}</span>
              <h1 class="inner-court__title" v-if="service.cf[500]">{{service.cf[500]}}</h1>
              <p class="inner-court__subtitle" v-if="service.cf[501]">{{service.cf[501]}}</p>
              <ul class="inner-court__list" v-if="service.cf[502] || service.cf[503] || service.cf[504] || service.cf[505] || service.cf[506]">
                <li class="inner-court__link" v-if="service.cf[502]">
                  <div class="inner-court__figure">
                    <span>1</span>
                  </div>
                  {{service.cf[502]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[503]">
                  <div class="inner-court__figure">
                    <span>2</span>
                  </div>
                  {{service.cf[503]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[504]">
                  <div class="inner-court__figure">
                    <span>3</span>
                  </div>
                  {{service.cf[504]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[505]">
                  <div class="inner-court__figure">
                    <span>4</span>
                  </div>
                  {{service.cf[505]}}
                </li>
                <li class="inner-court__link" v-if="service.cf[506]">
                  <div class="inner-court__figure">
                    <span>5</span>
                  </div>
                  {{service.cf[506]}}
                </li>
              </ul>
            </div>
            <div class="court__pic">
              <picture @click="modal = true" v-if="service.id === 614"><source srcset="/static/img/img3.jpg"><img src="/static/img/img3.jpg" alt="" /></picture>
              <picture @click="modal = true" v-else-if="service.id === 583"><source srcset="/static/img/img2.jpg"><img src="/static/img/img2.jpg" alt="" /></picture>
              <picture @click="modal = true" v-else><source srcset="/static/img/img1.png"><img src="/static/img/img1.png" alt="" /></picture>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="for-whom__head">
      <div class="for-whom__head-icon"></div>
      <div class="for-whom__head-title">Хочу получить ходатайства бесплатно</div>
      <div class="for-whom__head-email">
        <input autocomplete="off" type="email" name="form[]" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
        <button @click="sendQuestion('ходатайства')"><span>Получить</span></button>
      </div>
    </div>

    <section class="cards">
      <div class='container'>
        <div class="cards__wrapper">
          <h2 class="cards__title" id="ya1">Не нужны дорогостоящие юристы</h2>
          <div class="cards__box box-cards">
            <div class="cards-container">
              <!-- Additional required wrapper -->
              <div class="cards-wrapper">
                <div class="cards-slide">
                  <div class="box-item">
                    <div class="box-item-header-wrapper">
                      <h4 class="box-item__header" v-if="service.cf[507]">{{service.cf[507]}}</h4>
                      <h4 class="box-item__header" v-else>Выиграю дело сам</h4>
                    </div>
                    <div class="box-item__body">
                      <ul class="box-item__list">
                        <slot v-if="service.cf[508]">
                          <li v-if="cf" v-for="(cf, i) in service.cf[508].replace(/-/g, '').split('\n')" :key="i">{{cf}}</li>
                        </slot>
                        <li v-else>10 комплектов документов, с шаблонами которых наши клиенты уже выигрывали дела</li>
                      </ul>
                      <p class="box-item__text" v-if="service.cf[509]">{{service.cf[509]}}</p>
                      <p class="box-item__text" v-else>Это популярный тариф – вам нужно потратить пару часов и действовать по нашей рекомендации</p>
                      <div class="box-item__footer">
                        <span class="box-item__price" v-if="service.cf[510]">{{service.cf[510]}}</span>
                        <span class="box-item__price" v-else>299 руб</span>
                        <div class="box-item__footer-wrapper">
                          <button class="box-item__btn" @click="selectPrice((service.cf[507]?service.cf[507]:'Выиграю дело сам'),(service.cf[510]?service.cf[510]:299),0)"><span>Заказать документы</span></button>
                        </div>
                      </div>
                  </div>
                  </div>
                </div>
                <div class="cards-slide">
                  <div class="box-item">
                    <div class="box-item-header-wrapper">
                      <h4 class="box-item__header" v-if="service.cf[511]">{{service.cf[511]}}</h4>
                      <h4 class="box-item__header" v-else>Подскажите как</h4>
                    </div>
                    <div class="box-item__body">
                      <ul class="box-item__list">
                        <slot v-if="service.cf[512]">
                          <li v-if="cf" v-for="(cf, i) in service.cf[512].replace(/-/g, '').split('\n')" :key="i">{{cf}}</li>
                        </slot>
                        <slot v-else>
                          <li>10 комплектов документов</li>
                          <li>Видеоразбор и урок по возврату ав в Вашей ситуации</li>
                          <li>Персональный разбор Вашего дела</li>
                        </slot>
                      </ul>
                      <p class="box-item__text" v-if="service.cf[513]">{{service.cf[513]}}</p>
                      <p class="box-item__text" v-else>
                        Самый популярный тариф. Вы разберетесь во всем сами и без труда решите свой вопрос</p>
                    </div>
                    <div class="box-item__footer">
                      <span class="box-item__price" v-if="service.cf[514]">{{service.cf[514]}}</span>
                      <span class="box-item__price" v-else>789 руб</span>
                      <div class="box-item__footer-wrapper">
                        <button class="box-item__btn" @click="selectPrice((service.cf[511]?service.cf[511]:'Подскажите как'),(service.cf[514]?service.cf[514]:789),0)"><span>Заказать документы</span></button>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="cards-slide">
                  <div class="box-item">
                    <div class="box-item-header-wrapper">
                      <h4 class="box-item__header" v-if="service.cf[515]">{{service.cf[515]}}</h4>
                      <h4 class="box-item__header" v-else>Дайте все готовое</h4>
                    </div>
                    <div class="box-item__body">
                      <ul class="box-item__list">
                        <slot v-if="service.cf[516]">
                          <li v-if="cf" v-for="(cf, i) in service.cf[516].replace(/-/g, '').split('\n')" :key="i">{{cf}}</li>
                        </slot>
                        <slot v-else>
                          <li>1 час видеоконсультации с юристом</li>
                          <li>Персональный разбор Вашего дела</li>
                          <li>Юрист подготовит и сделает всё сам</li>
                          <li>Что то четвертое</li>
                        </slot>
                      </ul>
                      <p class="box-item__text" v-if="service.cf[517]">{{service.cf[517]}}</p>
                      <p class="box-item__text" v-else>
                        Премиум-тариф – специалист все сделает за вас, напомнит о нужных действиях и будет всегда на связи</p>
                    </div>
                    <div class="box-item__footer">
                      <span class="box-item__price" v-if="service.cf[518]">{{service.cf[518]}}</span>
                      <span class="box-item__price" v-else>2499 руб</span>
                      <div class="box-item__footer-wrapper">
                        <button class="box-item__btn" @click="selectPrice((service.cf[515]?service.cf[515]:'Дайте все готовое'),(service.cf[518]?service.cf[518]:2499),0)"><span>Заказать документы</span></button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="history" v-if="service.cf[519] || service.cf[520] || service.cf[521] || service.cf[522] || service.cf[523] || service.cf[524] || service.cf[525] || service.cf[526]">
      <div class='container'>
        <div class="history__wrapper">
          <h1 class="history__title">Истории выигранных дел</h1>
          <div class="history__inner">
            <div class="history__items">
              <div class="history__item" v-if="service.cf[519] || service.cf[520]">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[519]">{{service.cf[519]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[520]">{{service.cf[520]}}</p>
                </div>
              </div>
              <div class="history__item" v-if="service.cf[521] || service.cf[522]">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[521]">{{service.cf[521]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[522]">{{service.cf[522]}}</p>
                </div>
              </div>
              <div class="history__item" v-if="service.cf[523] || service.cf[524]">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[523]">{{service.cf[523]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[524]">{{service.cf[524]}}</p>
                </div>
              </div>
              <div class="history__item" v-if="showAll">
                <div class="history__pictures">
                  <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                </div>
                <div class="history__text">
                  <h1 class="history__info" v-if="service.cf[525]">{{service.cf[525]}}</h1>
                  <p class="history__subinfo" v-if="service.cf[526]">{{service.cf[526]}}</p>
                </div>
              </div>
              <div class="history__btn-wrapper" v-if="!showAll && (service.cf[525] || service.cf[526])">
                <button class="history__btn" @click="showAll = true">Читать ещё</button>
              </div>
            </div>

            <div class="history__slider">
              <div class="history-container" data-mobile="false">

                <div class="history-wrapper">
                  <div class="history-slide" v-if="service.cf[519] || service.cf[520]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[519]">{{service.cf[519]}}</div>

                      </div>
                      <div class="item-history__body" v-if="service.cf[520]">{{service.cf[520]}}</div>
                    </div>
                  </div>
                  <div class="history-slide" v-if="service.cf[521] || service.cf[522]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[521]">{{service.cf[521]}}</div>

                      </div>
                      <div class="item-history__body" v-if="service.cf[522]">{{service.cf[522]}}</div>
                    </div>
                  </div>
                  <div class="history-slide" v-if="service.cf[523] || service.cf[524]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[523]">{{service.cf[523]}}</div>
                      </div>
                      <div class="item-history__body" v-if="service.cf[524]">{{service.cf[524]}}</div>
                    </div>
                  </div>
                  <div class="history-slide" v-if="service.cf[525] || service.cf[526]">
                    <div class="history-slide__item item-history">
                      <div class="item-history__header">
                        <div class="item-history__picture">
                          <picture><source srcset="/static/img/history/icon.svg" type="image/webp"><img src="/static/img/history/icon.svg" alt="" /></picture>
                        </div>
                        <div class="item-history__title" v-if="service.cf[525]">{{service.cf[525]}}</div>
                      </div>
                      <div class="item-history__body" v-if="service.cf[526]">{{service.cf[526]}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="for">
      <div class='container'>
        <div class="for__warpper">
          <h1 class="for__title title-for">Для кого</h1>
          <div class="for__inner">
            <div class="document__list list-document">
              <ul class="list-document__ul">
                <li v-if="service.cf[527]" class="list-document__link">{{service.cf[527]}}</li>
                <li v-if="service.cf[528]" class="list-document__link">{{service.cf[528]}}</li>
                <li v-if="service.cf[529]" class="list-document__link">{{service.cf[529]}}</li>
                <li v-if="service.cf[530]" class="list-document__link">{{service.cf[530]}}</li>
                <li v-if="service.cf[531]" class="list-document__link">{{service.cf[531]}}</li>
              </ul>
            </div>
            <div class="for__btn-wrapper">
              <button class="for__btn"><a href="#ya1">Буду действовать</a></button>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="popup popup-reg is-active" v-if="text">
      <div class="popup__wrapper">
        <div class="popup__inner">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" type="button" @click="text=null, price=null"></button>
            <h4 class="popup__title">{{text}}</h4>
            <span class="popup__price" v-if="price">{{price}} руб</span>
            <div class="form">
              <div class="form-popup">
                <div class="popup-line" v-if="group.name">
                  <div class="nice-select" tabindex="0" style="width: 100%;"><span class="current">{{group.name}}</span></div>
                </div>
                <div class="popup-line" v-if="service.cf[492]">
                  <div class="nice-select" tabindex="0" style="width: 100%;"><span class="current">{{service.cf[492]}}</span></div>
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="Город" class="input input__name" v-model="city" />
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="Имя" class="input input__name" v-model="name" />
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="Телефон" class="input input__tel" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                </div>
                <div class="popup-input">
                  <input autocomplete="off" type="text" name="form[]" placeholder="E-mail" class="input input__email" v-model="email" data-inputmask="'alias': 'email'"/>
                </div>
                <div class="popup-send-btn-wrapper">
                  <button class="popup-send-btn" @click="sendQuestion">Получить документы по моему делу</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Modal
      v-show="modal"
      @close="modal = false"
      :isClose="true"
    >
      <template v-slot:body>
        <div>
          <picture v-if="service.id === 614"><source srcset="/static/img/img3.jpg"><img src="/static/img/img3.jpg" alt="" /></picture>
          <picture v-else-if="service.id === 583"><source srcset="/static/img/img2.jpg"><img src="/static/img/img2.jpg" alt="" /></picture>
          <picture v-else><source srcset="/static/img/img1.png"><img src="/static/img/img1.png" alt="" /></picture>
        </div>
      </template>
    </Modal>
  </main>

</template>

<script>
  import axios from '@/router/http'
  import Inputmask from 'inputmask'
  import $ from 'jquery'
  import Modal from './include/Modal'
  export default {
    name: 'service',
    components: {Modal},
    data () {
      return {
        service: {
          cf: {}
        },
        group: { cf: {} },
        cat: { cf: {} },
        showAll: false,
        text: null,
        name: null,
        price: null,
        email: null,
        phone: null,
        city: null,
        urist: null,
        modal: false
      }
    },
    methods: {
      initPage () {
        axios.get('https://bez.v-avtoservice.com/list/get-listc?id=' + this.$route.params.id).then(response => {
          this.service = response.data
          if (!this.service.cf) this.service.cf = {}
          if (this.service.cf[495]) {
            axios.get('https://bez.v-avtoservice.com/list/get-listc?id=' + this.service.cf[495]).then(response => {
              this.group = response.data
              if (this.group.cf[532]) {
                axios.get('https://bez.v-avtoservice.com/list/get-listc?id=' + this.group.cf[532]).then(response => {
                  this.cat = response.data
                })
              }
              if (!this.group.cf) this.group.cf = {}
            })
          }
          setTimeout(() => {
            // eslint-disable-next-line
            new Swiper('.cards-container', {
              observer: true,
              wrapperClass: 'cards-wrapper',
              slideClass: 'cards-slide',
              observeParents: true,
              slidesPerView: 3,
              spaceBetween: 0,
              speed: 800,
              breakpoints: {
                320: {
                  slidesPerView: 'auto',
                  spaceBetween: 0
                },
                376: {
                  slidesPerView: 1
                },
                728: {
                  slidesPerView: 2
                },
                767: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 3
                },
                1292: {
                  slidesPerView: 3
                }
              }
            })
            // eslint-disable-next-line
            new Swiper('.history-container', {
              wrapperClass: 'history-wrapper',
              slideClass: 'history-slide',
              loop: true,
              observer: true,
              observeParents: true,
              slidesPerView: 3,
              spaceBetween: 0,
              speed: 800,
              breakpoints: {
                320: {
                  slidesPerView: 'auto',
                  spaceBetween: -5
                },
                376: {
                  slidesPerView: 1
                },
                728: {
                  slidesPerView: 2
                },
                767: {
                  slidesPerView: 2
                },
                992: {
                  slidesPerView: 3
                },
                1292: {
                  slidesPerView: 3
                }
              }
            })
          }, 1000)
        })
        var self = this
        $(document).mouseup(function (e) {
          var container = $('.popup__content')
          if (container.has(e.target).length === 0) {
            self.text = null
          }
        })
      },
      selectPrice (name, price, urist) {
        this.text = name
        this.price = price
        this.urist = urist
        Inputmask().mask(document.querySelectorAll('input'))
        setTimeout(() => {
          Inputmask().mask(document.querySelectorAll('input'))
        }, 1000)
      },
      sendQuestion (element) {
        if (element === 'ходатайства') {
          var formDataHodataistva = new FormData()
          formDataHodataistva.append('crm', '16')
          formDataHodataistva.append('pipe', '34')
          formDataHodataistva.append('contact[name]', 'Заявка "Получить ходатайства"')
          formDataHodataistva.append('contact[467]', this.email)
          formDataHodataistva.append('lead[468]', 'Ходатайства и заявления в суд')
          formDataHodataistva.append('lead[469]', 'Ходатайства и заявления в суд')
          return axios.post('https://bez.v-avtoservice.com/api/import-lead',
            formDataHodataistva,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            console.log(res.data)
              alert('Спасибо, ваша заявка отправлена')
          })
        }
        if (!this.email) alert('Вам необходимо указать E-mail')
        else {
          if (this.urist) {
            setTimeout(() => {
              var formData = new FormData()
              formData.append('crm', '11')
              formData.append('pipe', '22')
              formData.append('contact[name]', this.name)
              formData.append('contact[199]', this.phone)
              formData.append('contact[200]', this.email)
              formData.append('contact[207]', this.city)
              formData.append('lead[price]', this.price)
              formData.append('lead[204]', this.city)
              formData.append('lead[214]', 'без-юриста.рф')
              formData.append('note', 'Группа: ' + this.group.name + '<br> Услуга: ' + this.service.name)

              axios.post('https://urist.v-avtoservice.com/api/import-lead',
                formData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              ).then(res => {
                if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
                else alert('Спасибо, ваша заявка отправлена')
              })
            }, 1)
          }
          var formData = new FormData()
          formData.append('crm', '16')
          formData.append('pipe', '34')
          formData.append('contact[name]', this.name)
          formData.append('contact[466]', this.phone)
          formData.append('contact[467]', this.email)
          formData.append('contact[473]', this.city)
          formData.append('lead[price]', this.price)
          formData.append('lead[471]', this.city)
          formData.append('lead[534]', this.cat.name)
          formData.append('lead[468]', this.group.name)
          formData.append('lead[469]', this.service.name)
          axios.post('https://bez.v-avtoservice.com/api/import-lead',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            console.log(res.data)
            if (res.data.link.result.payment_link) {
              window.location.href = res.data.link.result.payment_link
            } else if (res.data.link.result.error) {
              console.log(res.data.link.result.error_message)
              alert('ошибка, попробуйте позже')
            } else alert('Спасибо, ваша заявка отправлена')
          })
        }
      }
    },
    mounted () {
      this.initPage()
    },
    watch: {
      $route (to, from) {
        this.initPage()
      },
      'selectService.id' (val, oldVal) {
        if (val !== oldVal) {
          setTimeout(() => {
            this.selectService.show = 0
          }, 100)
        }
      }
    }
  }
</script>

<style scoped>
 .popup-line .nice-select::after {
   display: none;
 }
</style>



// WEBPACK FOOTER //
// src/components/services.vue